import PropTypes from 'prop-types';

const orderErrorPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});

export { orderErrorPropTypes };
